import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import '../sidebar/Sidebar.css';
import { hasPrivilege } from '../utils/hasPrivilege';
import Select from 'react-select';

const Sidebar = ({ isCollapsed, onToggle }) => {
  const { userData } = useUser();
  const token = localStorage.getItem('auth-token');
  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(
    localStorage.getItem('selectedCenter') || ''
  );

  const [showOptions, setShowOptions] = useState(
    JSON.parse(localStorage.getItem('showOptions')) || false
  );
  const [activeSection, setActiveSection] = useState(
    localStorage.getItem('activeSection') || null
  );



  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem('centerSelectedOnce') === 'true') {
      localStorage.removeItem('centerSelectedOnce');
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('activeSection', activeSection);
  }, [activeSection]);

  useEffect(() => {
    const fetchAcademies = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_API_CENTER, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        const data = await response.json();

        if (data && data.data.academies) {
          let filteredCenters = data.data.academies;

          if (userData?.userType !== "ADMIN" && userData?.academyIds?.length) {
            filteredCenters = filteredCenters.filter(center =>
              userData.academyIds.includes(center.id)
            );
          }

          setCenters(filteredCenters);
          if (filteredCenters.length === 1) {
            const onlyCenterId = filteredCenters[0].id.toString();

            const storedCenter = localStorage.getItem('selectedCenter');

            if (!storedCenter || storedCenter !== onlyCenterId) {
              localStorage.setItem('selectedCenter', onlyCenterId);
              localStorage.setItem('centerSelectedOnce', 'true');
              window.location.reload();
            }

            setSelectedCenter(onlyCenterId);
          }


        }
      } catch (error) {
        console.error('Error fetching academies:', error);
      }
    };

    fetchAcademies();
  }, [userData]);

  useEffect(() => {
    if (selectedCenter) {
      localStorage.setItem('selectedCenter', selectedCenter);
    }
  }, [selectedCenter]);

  const [settings, setSettings] = useState({
    coachingEnabled: false,
    courtBookingEnabled: false
  });
  useEffect(() => {
    if (!selectedCenter) return;

    fetch(`${process.env.REACT_APP_API_ACADEMY_SETTINGS}/${selectedCenter}/settings`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
      .then(response => response.json())
      .then(data => {
        const coachingEnabled = data.data.academySettingForm.settingMap.COACHING_ENABLED === "true";
        const courtBookingEnabled = data.data.academySettingForm.settingMap.COURT_BOOKING_ENABLED === "true";
        setSettings({
          coachingEnabled,
          courtBookingEnabled
        });

      })
      .catch(error => console.error('Error:', error));
  }, [selectedCenter]);



  const handleCenterChange = (event) => {
    const centerId = event.target.value;
    setSelectedCenter(centerId);
    localStorage.setItem('selectedCenter', centerId);
    window.location.reload();
  };

  const handleClick = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  const handleSubsectionClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <nav>
        <div className="sidebar-toggle" onClick={onToggle}>
          {window.innerWidth <= 600
            ? "\u25B6\uFE0E"
            : isCollapsed
              ? "\u25B6\uFE0E"
              : "\u25C0\uFE0E"
          }

        </div>
        <ul>
          <li>
            <div className="floating-select-centre">
              <Select
                options={centers.map(center => ({
                  value: center.id,
                  label: center.name
                }))}
                value={centers.find(center => center.id === Number(selectedCenter)) && {
                  value: Number(selectedCenter),
                  label: centers.find(center => center.id === Number(selectedCenter)).name
                }}
                onChange={option => {
                  setSelectedCenter(option ? option.value : null);
                  localStorage.setItem('selectedCenter', option ? option.value : '');
                  window.location.reload();
                }}
                placeholder="Select a Centre"
                classNamePrefix="react-select"
                className={`sales-filter-centre ${selectedCenter ? "has-value" : ""}`}
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: 'transparent',
                    color: 'white',
                    minHeight: '50px',
                    whiteSpace: 'normal',
                    overflow: 'visible',
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    color: 'white',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: 'white',
                    whiteSpace: 'normal',
                    overflow: 'visible',
                  }),
                  input: (provided) => ({
                    ...provided,
                    color: 'white',
                  }),
                  clearIndicator: (base) => ({
                    ...base,
                    color: 'white',
                    ':hover': {
                      color: 'white',
                    },
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    color: 'white',
                    ':hover': {
                      color: 'white',
                    },
                    svg: {
                      fill: 'white',
                      stroke: 'white',
                    },
                  }),
                  menu: (base) => ({
                    ...base,
                    width: 'auto',
                    minWidth: '210px',
                    zIndex: 9999,
                  }),
                  option: (base) => ({
                    ...base,
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                  })
                }}

                isClearable
              />
              {selectedCenter && <label htmlFor="academyFilter"></label>}
            </div>
          </li>

          {hasPrivilege(userData, 'ACADEMY') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    viewBox="0 0 22 22"
                    fill="none"
                    stroke="#dcdcdc"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 11L12 5l9 6" />
                    <path d="M5 11v8a1 1 0 0 0 1 1h3v-5h6v5h3a1 1 0 0 0 1-1v-8" />
                    <path d="M9 21V16h6v5" />
                  </svg>
                </span>
                {isCollapsed ? '' : <span className="text">Academy</span>}
              </Link>
              <ul className='subsection'>
                {hasPrivilege(userData, 'ACADEMY', 'ACADEMY_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/academylist"
                      className={window.location.pathname === '/academylist' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Academy List
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'PLAYING_PLAN', 'PLANS_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/tierList"
                      className={window.location.pathname === '/tierList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Academy Tier List
                    </Link>
                  </li>
                )}
                {/* {hasPrivilege(userData, 'ACADEMY', 'CREATE_NEW_ACADEMY_VIEW') && (
                  <li>
                    <Link
                      to="/newAcademy"
                      className={window.location.pathname === '/newAcademy' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Create Academy
                    </Link>
                  </li>
                )} */}
                {hasPrivilege(userData, 'ACADEMY', 'ACADEMY_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/academyFeatures"
                      className={window.location.pathname === '/academyFeatures' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Academy Features
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'ACADEMY', 'DISABLED_ACADEMY_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/disabledAcademy"
                      className={window.location.pathname === '/disabledAcademy' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Disabled Academy
                    </Link>
                  </li>
                )}

              </ul>
            </li>
          )}

          {hasPrivilege(userData, 'SPORTS') && (
            <li className="menu-item">
              <Link
                to="/"
                onClick={() => setActiveSection(null)}
              >
                <span className="icon">
                  <svg
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                    xmlSpace="preserve"
                    width="26"
                    height="26"
                    strokeWidth="2.3"
                  >
                    <g>
                      <path
                        fill="#dcdcdc"
                        d="M31.708,227.439c0.826,0.708,1.877,1.09,2.964,1.09c0.65,0,1.273-0.132,1.869-0.397l29.06-13.14l23.681,19.035
          c0.798,0.647,1.808,0.997,2.844,0.997c1.036,0,2.04-0.35,2.842-0.997l23.682-19.035l29.059,13.14
          c0.592,0.265,1.219,0.397,1.87,0.397c1.082,0,2.138-0.382,2.964-1.09c1.328-1.154,1.88-2.991,1.409-4.682l-26.368-93.284h1.043
          v-24.239c0-4.331-1.016-8.521-3.026-12.462c-2.838-5.554-7.484-10.25-13.435-13.576c-5.951-3.333-12.879-5.101-20.04-5.101
          c-9.568,0.008-18.607,3.131-25.454,8.801c-3.419,2.828-6.118,6.153-8.019,9.876c-2.013,3.934-3.03,8.123-3.03,12.462v24.223h1.044
          l-26.365,93.3C29.823,224.448,30.376,226.286,31.708,227.439z M88.562,221.8l-18.35-14.744l5.472-41.802h12.878V221.8z
          M88.562,158.119H76.614l3.279-25.088h8.669V158.119z M95.689,221.8l0.003-56.546h12.875l5.471,41.802L95.689,221.8z
          M95.692,158.119v-25.088h8.666l3.283,25.088H95.692z M128.264,165.254l14.296,50.58l-21.45-9.69l-5.351-40.89H128.264z
          M126.251,158.119h-11.422l-3.28-25.088h7.61L126.251,158.119z M66.002,105.234c0-2.679,0.635-5.281,1.889-7.742
          c1.896-3.715,5.098-6.917,9.26-9.254c4.397-2.453,9.568-3.762,14.943-3.762h0.062c7.049,0,13.899,2.337,18.802,6.411
          c2.329,1.924,4.143,4.151,5.398,6.605c1.258,2.461,1.892,5.063,1.892,7.742v18.724H66.002V105.234z M65.09,133.031h7.61
          l-3.279,25.088H57.999L65.09,133.031z M55.985,165.254h12.501l-5.347,40.89l-21.45,9.69L55.985,165.254z"
                      />
                      <polygon
                        fill="#dcdcdc"
                        points="138.428,358.367 113.502,363.804 27.327,449.986 62.022,484.677 148.196,398.503 153.636,373.579 
          216.74,310.467 201.534,295.263"
                      />
                      <rect
                        x="-1.699"
                        y="469.646"
                        transform="matrix(-0.7072 -0.707 0.707 -0.7072 -286.7766 842.932)"
                        fill="#dcdcdc"
                        width="65.712"
                        height="22.405"
                      />
                      <path
                        fill="#dcdcdc"
                        d="M465.73,123.257l-35.291,35.291l-36.085-36.086l48.041-48.04c-0.775-0.834-1.527-1.675-2.337-2.484
          c-1.336-1.34-2.726-2.625-4.14-3.872l-47.978,47.979l-36.085-36.086l34.107-34.106c-3.872-0.538-7.816-0.865-11.827-1.005
          l-28.698,28.694l-20.769-20.773c-3.107,1.09-6.184,2.297-9.237,3.598l23.596,23.592l-40.1,40.096l-31.981-31.98
          c-1.651,1.534-3.291,3.1-4.898,4.712c-0.538,0.53-1.056,1.091-1.59,1.636l32.055,32.051l-40.093,40.088l-24.098-24.098
          c-1.277,3.116-2.406,6.262-3.407,9.424l21.092,21.092l-25.784,25.782c0.432,3.691,1.051,7.344,1.874,10.958l30.325-30.33
          l36.089,36.086l-41.6,41.607c1.258,1.386,2.563,2.757,3.91,4.104c0.802,0.802,1.628,1.581,2.45,2.36l41.654-41.654l36.082,36.086
          l-31.319,31.318c2.78,0.701,5.589,1.309,8.431,1.784c0.755,0.132,1.515,0.226,2.278,0.335l27.022-27.019l22.689,22.681
          c3.162-0.989,6.309-2.118,9.44-3.388l-25.711-25.71l40.093-40.089l33.644,33.64c0.549-0.522,1.102-1.028,1.639-1.566
          c1.616-1.621,3.17-3.256,4.709-4.915l-33.578-33.577l40.096-40.096l25.17,25.165c1.297-3.053,2.488-6.13,3.586-9.245
          l-22.338-22.338l30.182-30.182C466.801,130.874,466.361,127.027,465.73,123.257z M345.437,86.37l36.089,36.092l-40.096,40.097
          l-36.089-36.085L345.437,86.37z M258.834,172.98l40.093-40.096l36.085,36.093l-40.089,40.088L258.834,172.98z M337.418,251.568
          l-36.081-36.092l40.093-40.089l36.081,36.085L337.418,251.568z M383.929,205.054l-36.085-36.077l40.096-40.104l36.085,36.085
          L383.929,205.054z"
                      />
                      <path
                        fill="#dcdcdc"
                        d="M504.931,93.979c-6.406-20.103-17.318-38.702-32.767-54.147c-15.438-15.438-34.037-26.349-54.143-32.759
          c-30.189-9.628-63.685-9.261-96.253,0.093c-32.58,9.362-64.338,27.751-91.229,54.63c-17.914,17.922-31.521,37.487-40.829,57.769
          c-13.973,30.414-18.241,62.48-13.166,92.647c5.047,30.181,19.468,58.399,42.168,81.08c15.122,15.118,32.701,26.591,51.682,34.037
          c28.479,11.184,60.094,13.28,91.21,5.717c31.135-7.547,61.729-24.706,88.6-51.585c35.828-35.851,56.604-80.341,60.954-123.95
          C513.319,135.711,511.349,114.097,504.931,93.979z M477.277,182.319c-7.968,27.751-23.842,55.362-47.355,78.861
          c-15.674,15.686-32.428,27.238-49.443,35.05c-25.532,11.706-51.628,15.032-75.944,10.95c-24.324-4.097-46.931-15.577-65.546-34.161
          c-12.399-12.408-21.621-26.606-27.618-41.88c-8.98-22.922-10.756-48.328-4.545-73.984c6.224-25.633,20.485-51.554,43.991-75.084
          c31.334-31.35,69.993-49.084,106.507-52.691c18.248-1.807,35.933-0.116,51.977,5.008c16.065,5.14,30.502,13.646,42.589,25.718
          c12.084,12.096,20.589,26.536,25.722,42.596C485.303,126.754,485.257,154.552,477.277,182.319z"
                      />
                    </g>
                  </svg>
                </span>
                {!isCollapsed && <span className="text">Sport</span>}
              </Link>

              <ul className='subsection'>

                {hasPrivilege(userData, 'SPORTS', 'SPORT_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/sportList"
                      className={window.location.pathname === '/sportList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Sport List
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'SPORTS', 'CREATE_NEW_SPORT_VIEW') && (
                  <li>
                    <Link
                      to="/newSport"
                      className={window.location.pathname === '/newSport' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Create Sport
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {hasPrivilege(userData, 'COUPONS') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon" style={{ display: 'flex', alignItems: 'center' }}>
                  <svg
                    fill="#dcdcdc"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 248.774 248.774"
                    xmlSpace="preserve"
                    width="26px"
                    height="26px"
                    strokeWidth="1.1"
                  >
                    <g>
                      <g>
                        <g>
                          <path d="M219.179,51.502H29.6C13.277,51.502,0,63.539,0,78.335v92.104c0,14.796,13.277,26.833,29.6,26.833h189.577 
              c16.318,0,29.597-12.037,29.597-26.833V78.335C248.774,63.539,235.495,51.502,219.179,51.502z M233.557,170.439 
              c0,6.404-6.455,11.616-14.38,11.616H29.6c-7.931,0-14.383-5.212-14.383-11.616V78.335c0-6.404,6.452-11.616,14.383-11.616 
              h189.577c7.926,0,14.38,5.212,14.38,11.616V170.439z"></path>
                          <rect x="67.622" y="104.742" width="15.217" height="13.097"></rect>
                          <rect x="67.622" y="157.127" width="15.217" height="13.097"></rect>
                          <rect x="67.622" y="78.548" width="15.217" height="13.097"></rect>
                          <rect x="67.622" y="130.936" width="15.217" height="13.094"></rect>
                          <path d="M152.026,103.507c0-11.874-9.858-21.611-21.616-21.611c-11.874,0-21.613,9.62-21.613,21.611 
              c0,12.115,9.741,21.613,21.613,21.613C142.168,125.12,152.026,115.503,152.026,103.507z M121.029,103.507 
              c0-5.225,4.276-9.379,9.379-9.379s9.379,4.157,9.379,9.379c0,5.227-4.276,9.381-9.379,9.381 
              C125.305,112.888,121.029,108.731,121.029,103.507z"></path>
                          <path d="M186.189,124.41c-11.874-0.043-21.651,9.544-21.697,21.537c-0.041,12.11,9.665,21.649,21.542,21.695 
              c11.76,0.043,21.646-9.546,21.692-21.537C207.767,134.227,197.947,124.45,186.189,124.41z M186.108,155.407 
              c-5.103,0-9.376-4.162-9.376-9.384c0-5.227,4.276-9.381,9.376-9.381c5.108,0,9.381,4.157,9.381,9.381 
              C195.492,151.248,191.216,155.407,186.108,155.407z"></path>
                          <rect x="109.054" y="117.595" transform="matrix(0.4696 -0.8829 0.8829 0.4696 -26.7873 205.8196)" width="97.7" height="15.217"></rect>
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
                {!isCollapsed && <span className="text">Coupons</span>}
              </Link>

              <ul className='subsection'>
                {hasPrivilege(userData, 'COUPONS', 'COUPONS_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/coupon"
                      className={window.location.pathname === '/coupon' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Coupon List
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'COUPONS', 'CREATE_NEW_COUPON') && (
                  <li>
                    <Link
                      to="/newCoupon"
                      className={window.location.pathname === '/newCoupon' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Create Coupon
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {hasPrivilege(userData, 'PAYMENT') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon" style={{ display: 'flex', alignItems: 'center' }}>
                  <svg
                    fill="#dcdcdc"
                    height="26px"
                    width="26px"
                    strokeWidth="1.2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 466.287 466.287"
                  >
                    <path d="M451.287,48.634H51.957c-8.284,0-15,6.716-15,15v144.789H33.21c-18.313,0-33.21,14.898-33.21,33.21v142.809 
      c0,18.313,14.897,33.21,33.21,33.21h261.991c18.313,0,33.21-14.898,33.21-33.21v-92.548h122.876c8.284,0,15-6.716,15-15V63.634 
      C466.287,55.35,459.571,48.634,451.287,48.634z M436.287,107.741c-13.644-4.653-24.453-15.463-29.106-29.107h29.106V107.741z 
      M96.064,78.634c-4.653,13.644-15.463,24.453-29.107,29.107V78.634H96.064z M33.21,238.423h261.991c1.77,0,3.21,1.44,3.21,3.21 
      v14.135H30v-14.135C30,239.863,31.44,238.423,33.21,238.423z M295.201,387.653H33.21c-1.77,0-3.21-1.44-3.21-3.21v-73.385h268.411 
      v73.385C298.411,386.212,296.971,387.653,295.201,387.653z M319.264,218.78c10.052-14.037,15.613-31.016,15.613-48.516 
      c0-45.91-37.351-83.26-83.26-83.26c-45.904,0-83.25,37.35-83.25,83.26c0,13.548,3.203,26.527,9.22,38.159H66.957v-79.915 
      c24.695-5.709,44.165-25.179,49.874-49.873h269.583c5.709,24.694,25.179,44.164,49.873,49.873v83.513 
      c-24.694,5.709-44.164,25.179-49.873,49.873h-58.003v-20.261C328.411,232.784,324.926,224.739,319.264,218.78z 
      M407.181,261.894c4.653-13.644,15.462-24.453,29.106-29.106v29.106H407.181z"/>
                    <text x="50%" y="58%" textAnchor="middle" fill="white" fontSize="90" fontFamily="Arial" dy=".3em">₹</text>
                  </svg>
                </span>
                {!isCollapsed && <span className="text">Payment</span>}
              </Link>


              <ul className='subsection'>
                {hasPrivilege(userData, 'PAYMENT', 'PAYMENT_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/paymentlist"
                      className={window.location.pathname === '/paymentlist' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Payment List
                    </Link>
                  </li>
                )}
                {selectedCenter && hasPrivilege(userData, 'PAYMENT', 'PAYMENT_DUES_VIEW') && (
                  <li>
                    <Link
                      to="/dues"
                      className={window.location.pathname === '/dues' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Dues
                    </Link>
                  </li>
                )}


                {hasPrivilege(userData, 'PAYMENT', 'PAYMENT_SUMMARY_VIEW') && (
                  <li>
                    <Link
                      to="/summary"
                      className={window.location.pathname === '/summary' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Summary
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'PAYMENT', 'SPORTS_PAYMENT_SUMMARY_VIEW') && (
                  <li>
                    <Link
                      to="/sportPaymentsummary"
                      className={window.location.pathname === '/sportPaymentsummary' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Sport Payment
                    </Link>
                  </li>
                )}

              </ul>
            </li>
          )}

          {hasPrivilege(userData, 'MARKETING') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon">
                  <svg
                    viewBox="0 0 1024 1024"
                    className="icon"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    fill="none"
                    stroke="#dcdcdc"
                    strokeWidth="1.2"
                  >
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path d="M190.171429 782.628571l277.942857-277.942857 160.914285 146.285715L870.4 365.714286v555.885714l-687.542857 7.314286z" fill="#ffffff"></path>
                      <path d="M870.4 928.914286c-14.628571 0-21.942857-7.314286-21.942857-21.942857V387.657143c0-14.628571 7.314286-21.942857 21.942857-21.942857 14.628571 0 21.942857 7.314286 21.942857 21.942857v519.314286c0 14.628571-7.314286 21.942857-21.942857 21.942857zM658.285714 928.914286h-14.628571c-7.314286 0-14.628571-7.314286-14.628572-14.628572V650.971429c0-7.314286 7.314286-14.628571 14.628572-14.628572H658.285714c7.314286 0 14.628571 7.314286 14.628572 14.628572v263.314285c0 7.314286-7.314286 14.628571-14.628572 14.628572zM424.228571 928.914286h-7.314285c-7.314286 0-14.628571-7.314286-14.628572-14.628572V614.4c0-7.314286 7.314286-14.628571 14.628572-14.628571h7.314285c7.314286-7.314286 14.628571 0 14.628572 14.628571v299.885714c0 7.314286-7.314286 14.628571-14.628572 14.628572zM182.857143 928.914286h-21.942857c-7.314286 0-7.314286-7.314286-7.314286-7.314286v-131.657143c0-7.314286 7.314286-7.314286 7.314286-7.314286h21.942857c7.314286 0 7.314286 7.314286 7.314286 7.314286v131.657143s0 7.314286-7.314286 7.314286zM190.171429 614.4l277.942857-256L585.142857 453.485714l219.428572-241.371428 65.828571 73.142857 58.514286-226.742857-241.371429 36.571428 73.142857 80.457143-182.857143 197.485714-109.714285-95.085714-314.514286 292.571429z" fill="#ffffff"></path>
                    </g>
                  </svg>
                </span>
                {!isCollapsed && <span className="text">Marketing</span>}
              </Link>


              <ul className="subsection">
                {hasPrivilege(userData, 'MARKETING', 'SUMMER_ENROLLMENTS_VIEW') && (
                  <li>
                    <Link
                      to="/Summer"
                      className={window.location.pathname === "/Summer" ? "active" : ""}
                      onClick={handleSubsectionClick}
                    >
                      Summer Enrollments
                    </Link>
                  </li>
                )}
                {/* {hasPrivilege(userData, 'MARKETING', 'DROPOFFS_OF_SUMMER_CAMP_VIEW') && (
                  <li>
                    <Link
                      to="/SummerColdLead"
                      className={window.location.pathname === "/SummerColdLead" ? "active" : ""}
                      onClick={handleSubsectionClick}
                    >
                      Drop Off (Summer Lead)
                    </Link>
                  </li>
                )} */}
                {hasPrivilege(userData, 'MARKETING', 'ALL_LEADS_VIEW') && (
                  <li>
                    <Link
                      to="/dashboard"
                      className={window.location.pathname === '/dashboard' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      All Leads
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'MARKETING', 'TRIAL_ATTENDED_VIEW') && (
                  <li>
                    <Link
                      to="/Trialattended"
                      className={window.location.pathname === '/Trialattended' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Trial Attended
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'MARKETING', 'TRIAL_MISSED_VIEW') && (
                  <li>
                    <Link
                      to="/Trialmissed"
                      className={window.location.pathname === '/Trialmissed' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Trial Missed
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'MARKETING', 'TRIAL_RESCHEDULED_VIEW') && (
                  <li>
                    <Link
                      to="/Trialrescheduled"
                      className={window.location.pathname === '/Trialrescheduled' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Trial Rescheduled
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'MARKETING', 'TRIAL_CONVERTED_VIEW') && (
                  <li>
                    <Link
                      to="/Trialconverted"
                      className={window.location.pathname === '/Trialconverted' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Trial Converted
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'MARKETING', 'JUNK_LEADS_VIEW') && (
                  <li>
                    <Link
                      to="/coldleads"
                      className={window.location.pathname === '/coldleads' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Junk Leads
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'MARKETING', 'EQUIRY_VIEW') && (
                  <li>
                    <Link
                      to="/Enquiry"
                      className={window.location.pathname === '/Enquiry' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Enquiry
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {selectedCenter && hasPrivilege(userData, 'CBU') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon"><svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  width="27px"
                  height="27px"
                  className="inline-block align-middle"
                >
                  <path
                    d="M18 7.16C17.94 7.15 17.87 7.15 17.81 7.16C16.43 7.11 15.33 5.98 15.33 4.58C15.33 3.15 16.48 2 17.91 2C19.34 2 20.49 3.16 20.49 4.58C20.48 5.98 19.38 7.11 18 7.16Z"
                    stroke="#dcdcdc"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.9699 14.44C18.3399 14.67 19.8499 14.43 20.9099 13.72C22.3199 12.78 22.3199 11.24 20.9099 10.3C19.8399 9.59004 18.3099 9.35003 16.9399 9.59003"
                    stroke="#dcdcdc"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5.96998 7.16C6.02998 7.15 6.09998 7.15 6.15998 7.16C7.53998 7.11 8.63998 5.98 8.63998 4.58C8.63998 3.15 7.48998 2 6.05998 2C4.62998 2 3.47998 3.16 3.47998 4.58C3.48998 5.98 4.58998 7.11 5.96998 7.16Z"
                    stroke="#dcdcdc"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.99994 14.44C5.62994 14.67 4.11994 14.43 3.05994 13.72C1.64994 12.78 1.64994 11.24 3.05994 10.3C4.12994 9.59004 5.65994 9.35003 7.02994 9.59003"
                    stroke="#dcdcdc"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 14.63C11.94 14.62 11.87 14.62 11.81 14.63C10.43 14.58 9.32996 13.45 9.32996 12.05C9.32996 10.62 10.48 9.46997 11.91 9.46997C13.34 9.46997 14.49 10.63 14.49 12.05C14.48 13.45 13.38 14.59 12 14.63Z"
                    stroke="#dcdcdc"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.08997 17.78C7.67997 18.72 7.67997 20.26 9.08997 21.2C10.69 22.27 13.31 22.27 14.91 21.2C16.32 20.26 16.32 18.72 14.91 17.78C13.32 16.72 10.69 16.72 9.08997 17.78Z"
                    stroke="#dcdcdc"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg></span>
                {!isCollapsed && <span className="text">CBU</span>}
              </Link>
              <ul className='subsection'>
                {hasPrivilege(userData, 'CBU', 'CREATE_COACH_MODIFY') && (
                  <li>
                    <Link
                      to="/createCoach"
                      className={window.location.pathname === '/createCoach' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Create Coach
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CBU', 'COACH_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/coachList"
                      className={window.location.pathname === '/coachList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Coach List
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CBU', 'COACH_ATTENDANCE_VIEW') && (
                  <li>
                    <Link
                      to="/coachAttendance"
                      className={window.location.pathname === '/coachAttendance' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Coach Attendance
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CBU', 'COACH_FEEDBACK_VIEW') && (
                  <li>
                    <Link
                      to="/coachFeedback"
                      className={window.location.pathname === '/coachFeedback' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Coach Feedback
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CBU', 'USER_FEEDBACK_VIEW') && (
                  <li>
                    <Link
                      to="/userFeedback"
                      className={window.location.pathname === '/userFeedback' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      User Feedback
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CBU', 'NEW_ENROLLMENTS_VIEW') && (
                  <li>
                    <Link
                      to="/newEnrollments"
                      className={window.location.pathname === '/newEnrollments' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      New Enrollments
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CBU', 'DROPOUTS_VIEW') && (
                  <li>
                    <Link
                      to="/dropouts"
                      className={window.location.pathname === '/dropouts' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Drop Outs
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CBU', 'PLAYER_COACH_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/playerCoachList"
                      className={window.location.pathname === '/playerCoachList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Player Coach List
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CBU', 'ACTIVE_PLAYER_VIEW') && (
                  <li>
                    <Link
                      to="/activePlayer"
                      className={window.location.pathname === '/activePlayer' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Active Player
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {selectedCenter && hasPrivilege(userData, 'CTU') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  className="inline-block align-middle"
                  stroke="#dcdcdc"
                  strokeWidth="1.2"
                >
                  <path
                    d="M3 9H21M7 3V5M17 3V5M6 12H8M11 12H13M16 12H18M6 15H8M11 15H13M16 15H18M6 18H8M11 18H13M16 18H18M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
                    stroke="#dcdcdc"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                  />
                </svg>
                {!isCollapsed && <span className="text">CTU</span>}
              </Link>
              <ul className='subsection'>
                {hasPrivilege(userData, 'CTU', 'CURRICULUM_VIEW') && (
                  <li>
                    <Link
                      to="/Curriculum"
                      className={window.location.pathname === '/Curriculum' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Curriculum
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {hasPrivilege(userData, 'HR', 'HR_VIEW') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 438.37"
                  fill="#dcdcdc"
                  width="24px"
                  height="24px"
                  className="inline-block align-middle"
                >
                  <path d="M280.48 121.98c-.62-5.11 14.54-24.64 17.32-34 5.94-9.42 8.04-24.43 1.57-34.4-2.57-3.96-1.47-7.39-1.47-12.86 0-54.28-95.1-54.3-95.1 0 0 6.85 1.57 8.47-2.13 13.89-6.23 9.01-3.03 25.02 2.23 33.4 3.37 9.84 19.27 28.43 18.17 33.99-1 27.86 59.58 26.94 59.41-.02zM114.5 383.61V225.86h70.96c30.08 5.39 60.15 21.71 90.24 40.64h55.11c24.95 1.49 38.03 26.78 13.76 43.41-19.31 14.18-44.82 13.37-70.97 11.02-18.03-.9-18.8 23.33 0 23.41 6.54.52 13.63-1.02 19.82-1.02 32.65-.05 59.48-6.28 75.93-32.05l8.25-19.26 81.98-40.64c41.02-13.5 70.16 29.4 39.96 59.26-59.4 43.2-120.28 78.75-182.58 107.46-45.23 27.51-90.48 26.57-135.69 0l-66.77-34.48zM0 210.7h93.13v188.76H0V210.7zm389.62-34.05h2.69c2.41 0 4.4-1.99 4.4-4.41v-7.12c0-2.41-1.99-4.4-4.4-4.4h-15.93c-2.41 0-4.4 1.99-4.4 4.4v7.12c0 2.42 1.99 4.41 4.4 4.41h2.73l-5.23 26.54h20.76l-5.02-26.54zm-27.86-38.74c.5-4.1-11.69-19.8-13.92-27.32-4.78-7.58-6.47-19.64-1.27-27.66 2.07-3.18 1.19-5.94 1.19-10.34 0-43.62 76.44-43.64 76.44 0 0 5.51-1.26 6.81 1.71 11.17 5 7.24 2.44 20.11-1.79 26.85-2.71 7.91-15.5 22.84-14.61 27.32.81 22.4-47.89 21.65-47.75-.02zm59.34 13.08c9.39 6.01 22.72 10.94 33.37 14.5 20.93 6.96 20.87 7.94 20.72 37.7h-73.94l19.85-52.2zm-175.29 19.18h-3.34c-3 0-5.46-2.48-5.46-5.48v-8.86c0-3.01 2.46-5.48 5.46-5.48h19.81c3.01 0 5.48 2.47 5.48 5.48v8.86c0 3-2.47 5.48-5.48 5.48h-3.38l6.49 33.02h-25.82l6.24-33.02zm114.24 33.02c-2.57-33.31 3.95-31.87-23.93-42.3-13.92-5.21-26.29-11.82-39.06-19.81l-23.93 62.11h86.92zm-153.39-64.94c-11.7 7.47-22.86 13.62-36.12 18.04-26.03 8.66-25.95 9.87-25.78 46.9h86.59l-24.69-64.94z" />
                </svg>
                {!isCollapsed && <span className="text">HR</span>}
              </Link>
              <ul className='subsection'>
                {hasPrivilege(userData, 'HR', 'DEPARTMENT_AND_JOB_VIEW') && (
                  <li>
                    <Link
                      to="/departmentAndJob"
                      className={window.location.pathname === '/departmentAndJob' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Department And Job
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'HR', 'EMPLOYEE_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/employeeHr"
                      className={window.location.pathname === '/employeeHr' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Employee List
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'HR', 'EMPLOYEE_ATTENDANCE') && (
                  <li>
                    <Link
                      to="/employeeHrReport"
                      className={window.location.pathname === '/employeeHrReport' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Employee Attendance
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {hasPrivilege(userData, 'TICKET') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <svg
                  viewBox="0 0 297 297"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  fill="#dcdcdc"
                  className="inline-block align-middle"
                >
                  <path d="M286.542,69.021c-13.263,0-24.053-10.79-24.053-24.053c0-5.775-4.683-10.458-10.457-10.458H44.969 c-5.775,0-10.458,4.683-10.458,10.458c0,13.263-10.79,24.053-24.053,24.053C4.683,69.021,0,73.703,0,79.479v138.043 c0,5.775,4.683,10.457,10.458,10.457c13.263,0,24.053,10.79,24.053,24.053c0,5.775,4.683,10.458,10.458,10.458h207.063 c5.774,0,10.457-4.683,10.457-10.458c0-13.263,10.79-24.053,24.053-24.053c5.775,0,10.458-4.682,10.458-10.457V79.479 C297,73.703,292.317,69.021,286.542,69.021z M276.085,208.291c-16.413,3.924-29.359,16.87-33.283,33.283H54.198 c-3.924-16.413-16.87-29.359-33.283-33.283V88.709c16.413-3.924,29.359-16.87,33.283-33.283h188.604 c3.924,16.413,16.87,29.359,33.283,33.283V208.291z" />
                  <path d="M53.596,107.191h26.046c5.775,0,10.457-4.682,10.457-10.457c0-5.775-4.682-10.458-10.457-10.458H53.596 c-5.775,0-10.458,4.683-10.458,10.458C43.138,102.51,47.82,107.191,53.596,107.191z" />
                  <path d="M108.184,107.191h26.045c5.775,0,10.458-4.682,10.458-10.457c0-5.775-4.683-10.458-10.458-10.458h-26.045 c-5.775,0-10.458,4.683-10.458,10.458C97.726,102.51,102.408,107.191,108.184,107.191z" />
                  <path d="M162.771,107.191h26.045c5.775,0,10.458-4.682,10.458-10.457c0-5.775-4.683-10.458-10.458-10.458h-26.045 c-5.775,0-10.458,4.683-10.458,10.458C152.313,102.51,156.996,107.191,162.771,107.191z" />
                  <path d="M243.404,86.276h-26.046c-5.775,0-10.457,4.683-10.457,10.458c0,5.775,4.682,10.457,10.457,10.457h26.046 c5.775,0,10.458-4.682,10.458-10.457C253.862,90.959,249.18,86.276,243.404,86.276z" />
                  <path d="M79.642,189.809H53.596c-5.775,0-10.458,4.682-10.458,10.457c0,5.775,4.683,10.458,10.458,10.458h26.046 c5.775,0,10.457-4.683,10.457-10.458C90.099,194.49,85.417,189.809,79.642,189.809z" />
                  <path d="M134.228,189.809h-26.045c-5.775,0-10.458,4.682-10.458,10.457c0,5.775,4.683,10.458,10.458,10.458h26.045 c5.775,0,10.458-4.683,10.458-10.458C144.686,194.49,140.004,189.809,134.228,189.809z" />
                  <path d="M188.816,189.809h-26.045c-5.775,0-10.458,4.682-10.458,10.457c0,5.775,4.683,10.458,10.458,10.458h26.045 c5.775,0,10.458-4.683,10.458-10.458C199.274,194.49,194.592,189.809,188.816,189.809z" />
                  <path d="M243.404,189.809h-26.046c-5.775,0-10.457,4.682-10.457,10.457c0,5.775,4.682,10.458,10.457,10.458h26.046 c5.775,0,10.458-4.683,10.458-10.458C253.862,194.49,249.18,189.809,243.404,189.809z" />
                  <path d="M60.429,169.059c0.94,1.019,2.161,1.535,3.632,1.535c1.454,0,2.664-0.512,3.597-1.523c0.908-0.987,1.369-2.449,1.369-4.346 v-27.337h7.588c1.607,0,2.862-0.388,3.729-1.154c0.907-0.798,1.367-1.856,1.367-3.144c0-1.28-0.451-2.338-1.342-3.146 c-0.861-0.779-2.125-1.176-3.754-1.176H51.456c-1.547,0-2.776,0.381-3.651,1.13c-0.924,0.792-1.392,1.865-1.392,3.192 c0,1.282,0.447,2.337,1.329,3.135c0.852,0.771,2.102,1.163,3.714,1.163h7.588v27.337C59.044,166.604,59.51,168.063,60.429,169.059z" />
                  <path d="M89.595,128.101c-1.455,0-2.667,0.518-3.602,1.541c-0.904,0.995-1.364,2.442-1.364,4.302v30.781 c0,1.861,0.465,3.314,1.381,4.316c0.94,1.03,2.146,1.553,3.585,1.553c1.487,0,2.72-0.517,3.659-1.535 c0.918-0.996,1.384-2.455,1.384-4.334v-30.781c0-1.882-0.467-3.336-1.388-4.324C92.31,128.611,91.08,128.101,89.595,128.101z" />
                  <path d="M119.575,136.482c1.818,0,3.354,0.421,4.564,1.255c1.246,0.855,2.358,2.193,3.306,3.972 c0.681,1.283,1.302,2.184,1.897,2.746c0.704,0.669,1.712,1.008,2.999,1.008c1.206,0,2.244-0.463,3.086-1.376 c0.821-0.89,1.238-1.935,1.238-3.107c0-1.864-0.729-3.839-2.163-5.868c-1.409-1.987-3.446-3.67-6.057-5.004 c-2.607-1.332-5.609-2.007-8.924-2.007c-2.715,0-5.311,0.492-7.72,1.461c-2.419,0.977-4.559,2.417-6.358,4.282 c-1.798,1.864-3.197,4.135-4.158,6.748c-0.954,2.586-1.438,5.549-1.438,8.809c0,2,0.191,3.92,0.568,5.706 c0.379,1.796,0.958,3.511,1.72,5.1c0.76,1.588,1.695,3.048,2.786,4.347c1.228,1.433,2.592,2.604,4.056,3.481 c1.465,0.879,3.112,1.534,4.898,1.947c1.758,0.406,3.728,0.612,5.861,0.612c2.847,0,5.387-0.467,7.55-1.389 c2.168-0.922,3.981-2.148,5.389-3.643c1.394-1.479,2.436-3.017,3.094-4.574c0.665-1.57,1.002-3.066,1.002-4.444 c0-1.267-0.447-2.345-1.328-3.201c-0.873-0.852-1.935-1.283-3.155-1.283c-1.439,0-2.525,0.466-3.227,1.382 c-0.567,0.738-1.044,1.689-1.405,2.796c-0.724,1.973-1.795,3.481-3.186,4.48c-1.384,0.992-3.12,1.496-5.16,1.496 c-1.887,0-3.544-0.447-4.93-1.33c-1.373-0.873-2.457-2.233-3.224-4.042c-0.793-1.878-1.195-4.293-1.195-7.174 c0-4.289,0.898-7.614,2.67-9.885C114.364,137.561,116.636,136.482,119.575,136.482z" />
                  <path d="M165.735,165.355c0.376,0.648,0.808,1.366,1.292,2.155c0.556,0.905,1.249,1.645,2.063,2.197 c0.866,0.588,1.969,0.886,3.28,0.886c1.441,0,2.618-0.417,3.501-1.241c0.899-0.843,1.356-1.862,1.356-3.028 c0-0.933-0.231-1.895-0.687-2.86c-0.421-0.888-1.026-1.885-1.846-3.042l-10.572-15.145l8.97-8.498 c1.399-1.336,2.109-2.748,2.109-4.195c0-1.252-0.464-2.328-1.378-3.197c-0.899-0.854-2.07-1.286-3.479-1.286 c-1.087,0-1.993,0.253-2.697,0.753c-0.576,0.409-1.248,1.018-2.055,1.86l-13.737,14.326v-11.097c0-1.883-0.465-3.338-1.386-4.324 c-0.939-1.008-2.17-1.518-3.657-1.518c-1.516,0-2.743,0.522-3.651,1.556c-0.87,0.993-1.312,2.436-1.312,4.287v29.05 c0,1.284,0.027,2.244,0.083,2.935c0.063,0.79,0.252,1.502,0.583,2.158c0.43,0.771,1.048,1.39,1.833,1.837 c0.778,0.445,1.607,0.671,2.464,0.671c1.467,0,2.691-0.51,3.638-1.512c0.933-0.986,1.405-2.452,1.405-4.357v-7.629l5.243-5.026 L165.735,165.355z" />
                  <path d="M208.988,136.961c1.526,0,2.71-0.375,3.519-1.113c0.835-0.763,1.259-1.771,1.259-2.997c0-1.208-0.424-2.207-1.259-2.97 c-0.809-0.738-1.992-1.113-3.519-1.113h-20.893c-1.266,0-2.34,0.197-3.194,0.587c-0.949,0.435-1.655,1.134-2.096,2.078 c-0.409,0.866-0.607,1.923-0.607,3.23v29.369c0,1.982,0.482,3.476,1.435,4.439c0.956,0.966,2.457,1.456,4.463,1.456h21.506 c1.507,0,2.69-0.384,3.518-1.139c0.853-0.781,1.286-1.798,1.286-3.024c0-1.261-0.432-2.296-1.286-3.078 c-0.827-0.756-2.011-1.14-3.518-1.14h-17.396v-9.021h15.372c1.496,0,2.653-0.379,3.44-1.129c0.798-0.762,1.202-1.746,1.202-2.928 c0-1.19-0.415-2.172-1.234-2.92c-0.792-0.721-1.938-1.085-3.408-1.085h-15.372v-7.503H208.988z" />
                  <path d="M228.835,169.059c0.939,1.019,2.162,1.535,3.633,1.535c1.454,0,2.663-0.512,3.597-1.523 c0.907-0.987,1.368-2.449,1.368-4.346v-27.337h7.588c1.607,0,2.863-0.388,3.729-1.154c0.907-0.798,1.368-1.856,1.368-3.144 c0-1.28-0.452-2.338-1.343-3.146c-0.861-0.779-2.125-1.176-3.754-1.176h-25.157c-1.548,0-2.777,0.381-3.652,1.13 c-0.923,0.792-1.392,1.865-1.392,3.192c0,1.282,0.448,2.337,1.329,3.135c0.853,0.771,2.102,1.163,3.715,1.163h7.588v27.337 C227.451,166.604,227.917,168.063,228.835,169.059z" />
                </svg>


                {!isCollapsed && <span className="text">Ticketing System</span>}
              </Link>
              <ul className='subsection'>
                {hasPrivilege(userData, 'TICKET', 'TICKETS_VIEW') && (
                  <li>
                    <Link
                      to="/ticket"
                      className={window.location.pathname === '/ticket' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Tickets
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'TICKET', 'EMPLOYEE_VIEW') && (
                  <li>
                    <Link
                      to="/employee"
                      className={window.location.pathname === '/employee' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Employee
                    </Link>
                  </li>
                )}


                {hasPrivilege(userData, 'TICKET', 'TICKET_CATEGORY_VIEW') && (
                  <li>
                    <Link
                      to="/ticketcategory"
                      className={window.location.pathname === '/ticketcategory' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Category
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'TICKET', 'TICKET_REPORT_VIEW') && (
                  <li>
                    <Link
                      to="/ticketReport"
                      className={window.location.pathname === '/ticketReport' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Ticket Report
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}
          {selectedCenter && hasPrivilege(userData, 'CENTRE_MANAGEMENT') && (

            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon">
                  <svg
                    fill="#dcdcdc"
                    height="24px"
                    width="24px"
                    version="1.2"
                    baseProfile="tiny"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="-351 153 256 256"
                    xmlSpace="preserve"
                    className="inline-block align-middle"
                  >
                    <path d="M-209.3,262.6h-18.3V233c0-14.4,11.6-26,26-26h52.1c14.3,0,26,11.7,26,26v29.6h-18v-24.4c0-1.6-1.1-2.7-2.7-2.7 c-1.6,0-2.7,1.1-2.7,2.7h0.2v24.5h-57.4v-24.5c0-1.6-1.1-2.7-2.7-2.7c-1.6,0-2.7,1.1-2.7,2.7L-209.3,262.6z M-175.6,202.2 c11.5,0,20.9-9.4,20.9-20.9s-9.4-20.9-20.9-20.9s-20.9,9.4-20.9,20.9S-187.1,202.2-175.6,202.2z M-343,265.7v28.2h24.1V406H-128V294 h25v-28.2v-0.1H-343z M-337.5,244.3V191c0-2.6,2.1-4.7,4.7-4.7h80.5c2.6,0,4.7,2.1,4.7,4.7v53.2c0,2.6-2.1,4.7-4.7,4.7h-29.1v7.3 h10.7v5.2h-3.2h-37.1h-3.2v-5.2h10.5v-7.3h-29.1C-335.4,248.9-337.5,246.9-337.5,244.3z M-292.6,246.1c1.5,0,2.7-1.1,2.7-2.7 c0-1.5-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7C-295.3,245-294.1,246.1-292.6,246.1z M-331.6,238.7h78.1v-46.6h-78.1V238.7z" />
                  </svg>
                </span>
                {!isCollapsed && <span className="text">Centre Management</span>}
              </Link>

              <ul className='subsection'>
                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'WALK_IN_ENQUIRY_FORM_VIEW') && (
                  <li>
                    <Link
                      to="/walkInFormEnquiry"
                      className={window.location.pathname === '/walkInFormEnquiry' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Walk-in Enquiry form
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'WALK_IN_ENQUIRY_VIEW') && (
                  <li>
                    <Link
                      to="/walkinenquiry"
                      className={window.location.pathname === '/walkinenquiry' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Walk-in Enquiries
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'COURT_LIGHT_VIEW') && (
                  <li>
                    <Link
                      to="/courtlights"
                      className={window.location.pathname === '/courtlights' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Court Lights
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'WALK_IN_SALES_VIEW') && (
                  <li>
                    <Link
                      to="/walkInSales"
                      className={window.location.pathname === '/walkInSales' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Walk-in Sales
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'USER_REWARDS') && (
                  <li>
                    <Link
                      to="/userRewards"
                      className={window.location.pathname === '/userRewards' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      User Rewards
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'DAILY_REVENUE_VIEW') && (

                  <li>
                    <Link
                      to="/dailyRevenueReport"
                      className={window.location.pathname === '/dailyRevenueReport' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Daily revenue report
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'RECONCILIATION_REPORT_VIEW') && (
                  <li>
                    <Link
                      to="/reconciliationReport"
                      className={window.location.pathname === '/reconciliationReport' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Reconciliation Report
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'CM_TEAM_REVENUE') && (
                  <li>
                    <Link
                      to="/cmTeamRevenue"
                      className={window.location.pathname === '/cmTeamRevenue' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      CM Team Revenue
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'DAILY_UTILIZATION_VIEW') && (
                  <li>
                    <Link
                      to="/dailyUtilisationReport"
                      className={window.location.pathname === '/dailyUtilisationReport' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Daily utilisation report
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'PER_COURT_UTILIZATION_VIEW') && (
                  <li>
                    <Link
                      to="/perCourtUtilization"
                      className={window.location.pathname === '/perCourtUtilization' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Court Utilisation report
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'WALK_IN_SALES_RECORD_VIEW') && (
                  <li>
                    <Link
                      to="/walkInSalesRecords"
                      className={window.location.pathname === '/walkInSalesRecords' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Walk-in Sales Records
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'CASH_TRACKING_VIEW') && (
                  <li>
                    <Link
                      to="/cashTracking"
                      className={window.location.pathname === '/cashTracking' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Cash Tracking
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {selectedCenter && hasPrivilege(userData, 'COACHING') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon"><svg
                  fill="#dcdcdc"
                  height="25px"
                  width="25px"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 512 512"
                  xmlSpace="preserve"
                  className="inline-block align-middle"
                >
                  <path d="M469.492,350.304c-27.2-38.193-64.762-66.834-108.626-82.828c-0.001,0-0.003-0.001-0.004-0.002 c-25.204-9.189-51.699-13.849-78.75-13.849c-27.051,0-53.547,4.659-78.75,13.849c-0.002,0-0.003,0.001-0.005,0.002 c-11.876,4.331-23.381,9.674-34.397,15.914v-78.67c0-5.656-4.584-10.24-10.24-10.24H10.24C4.584,194.48,0,199.065,0,204.72v209.92 c0,5.656,4.584,10.24,10.24,10.24h49.537c-5.013,19.055-7.553,38.721-7.553,58.633c0,5.656,4.584,10.24,10.24,10.24H501.76 c5.656,0,10.24-4.584,10.24-10.24C512,435.416,497.302,389.354,469.492,350.304z M70.819,214.96h27.322v10.24H70.819V214.96z M20.48,404.4V214.96h29.859v20.48c0,5.656,4.584,10.24,10.24,10.24h47.803c5.656,0,10.24-4.584,10.24-10.24v-20.48h29.858V404.4 H20.48z M271.873,473.273H72.95c0.793-16.461,3.505-32.674,8.08-48.393h77.69c5.656,0,10.24-4.584,10.24-10.24V307.281 c10.369-6.67,21.305-12.412,32.655-17.144c6.798,12.837,16.565,23.86,28.646,32.243c12.453,8.641,26.674,13.957,41.611,15.627 V473.273z M221.131,283.123c19.688-5.988,40.151-9.017,60.981-9.017c20.83,0,41.293,3.029,60.981,9.017 c-12.52,21.547-35.447,34.976-60.981,34.976S233.651,304.669,221.131,283.123z M292.352,473.272V338.007 c14.937-1.669,29.157-6.986,41.611-15.627c12.081-8.384,21.848-19.407,28.646-32.244c74.348,30.983,124.701,102.7,128.659,183.136 H292.352z" />

                  <path d="M388.05,128.635c0-0.002,0-0.003,0-0.005c-0.306-60.867-50.072-110.383-110.943-110.383 c-57.441,0-104.985,44.094-110.419,100.209H90.717c-5.656,0-10.24,4.584-10.24,10.24c0,5.656,4.584,10.241,10.24,10.241h75.871 c4.949,56.633,52.621,101.211,110.517,101.211c61.178,0,110.95-49.772,110.95-110.95L388.05,128.635z M277.106,38.727 c46.162,0,84.489,34.918,89.829,79.729H187.277C192.616,73.645,230.945,38.727,277.106,38.727z M277.106,219.667 c-16.585,0-32.13-4.505-45.51-12.331h13.274c5.656,0,10.24-4.584,10.24-10.24c0-5.656-4.584-10.24-10.24-10.24h-37.394 c-4.52-5.451-8.405-11.441-11.563-17.858h6.035c5.656,0,10.24-4.584,10.24-10.24c0-5.656-4.584-10.24-10.24-10.24h-13.202 c-0.687-3.14-1.231-6.331-1.582-9.583h179.89C362.185,184.261,323.703,219.667,277.106,219.667z" />

                  <path d="M316.416,357.376c-5.656,0-10.24,4.584-10.24,10.24v13.312c0,5.656,4.584,10.24,10.24,10.24s10.24-4.584,10.24-10.24 v-13.312C326.656,361.96,322.072,357.376,316.416,357.376z" />
                  <path d="M316.416,420.864c-5.656,0-10.24,4.584-10.24,10.24v13.312c0,5.656,4.584,10.24,10.24,10.24s10.24-4.584,10.24-10.24 v-13.312C326.656,425.448,322.072,420.864,316.416,420.864z" />
                  <path d="M40.96,302.08c-5.656,0-10.24,4.584-10.24,10.24V384c0,5.656,4.584,10.24,10.24,10.24c5.656,0,10.24-4.584,10.24-10.24 v-71.68C51.2,306.664,46.616,302.08,40.96,302.08z" />
                  <path d="M40.96,265.216c-5.656,0-10.24,4.584-10.24,10.24v6.144c0,5.656,4.584,10.24,10.24,10.24c5.656,0,10.24-4.584,10.24-10.24 v-6.144C51.2,269.8,46.616,265.216,40.96,265.216z" />
                </svg></span>
                {!isCollapsed && <span className="text">Coaching</span>}
              </Link>
              <ul className='subsection'>

                {hasPrivilege(userData, 'COACHING', 'ACADEMY_PLAYER_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/academyPlayerList"
                      className={window.location.pathname === '/academyPlayerList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Academy Player List
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'COACHING', 'ACADEMY_COACH_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/academyCoachList"
                      className={window.location.pathname === '/academyCoachList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Academy Coach List
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'COACHING', 'CREATE_NEW_BATCH_VIEW') && (
                  <li>
                    <Link
                      to="/createNewBatch"
                      className={window.location.pathname === '/createNewBatch' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Create Batch
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'COACHING', 'CREATE_NEW_PLAYER_VIEW') && (
                  <li>
                    <Link
                      to="/createNewPlayer"
                      className={window.location.pathname === '/createNewPlayer' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Create Player
                    </Link>
                  </li>
                )}

                {settings.coachingEnabled && (
                  <>
                    {hasPrivilege(userData, 'COACHING', 'BATCH_LIST_VIEW') && (
                      <li>
                        <Link
                          to="/batchList"
                          className={window.location.pathname === '/batchList' ? 'active' : ''}
                          onClick={handleSubsectionClick}
                        >
                          Batch List
                        </Link>
                      </li>
                    )}

                    {hasPrivilege(userData, 'COACHING', 'PLAYER_BATCHES_VIEW') && (
                      <li>
                        <Link
                          to="/playerBatch"
                          className={window.location.pathname === '/playerBatch' ? 'active' : ''}
                          onClick={handleSubsectionClick}
                        >
                          Player Batch
                        </Link>
                      </li>
                    )}
                  </>
                )}

                {hasPrivilege(userData, 'COACHING', 'BATCH_CANCELLATION_VIEW') && (
                  <li>
                    <Link
                      to="/batchCancellation"
                      className={window.location.pathname === '/batchCancellation' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Batch Cancellation
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'COACHING', 'CANCELLED_BATCHES_VIEW') && (
                  <li>
                    <Link
                      to="/cancelBatchList"
                      className={window.location.pathname === '/cancelBatchList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Cancelled Batch List
                    </Link>
                  </li>
                )}

              </ul>
            </li>
          )}

          {settings.courtBookingEnabled && selectedCenter && hasPrivilege(userData, 'COURTS') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)} >
                <svg
                  fill="#dcdcdc"
                  height="24px"
                  width="24px"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 300.16 300.16"
                  xmlSpace="preserve"
                  className="inline-block align-middle"
                >
                  <path d="M245.689,94.738L229.743,5.695H70.417L54.806,94.738H0v10.05h11.256v89.378h10.05v-5.628h15.477L16.214,294.465h267.732 l-20.569-105.994h15.477v5.628h10.05v-89.378h11.256v-9.983H245.689z M235.706,104.788h16.549v18.425h-16.549V104.788z M235.706,133.263h16.549v17.554h-16.549V133.263z M235.706,160.867h16.549v17.554h-16.549V160.867z M78.859,15.745h142.509 l14.137,78.993H64.99L78.859,15.745z M208.705,150.817l0.134-17.554h16.884v17.554H208.705z M225.656,160.867v17.554h-17.353 l0.201-17.554H225.656z M208.906,123.213l0.201-18.425h16.549v18.425H208.906z M181.704,150.817v-17.554h17.085l-0.201,17.554 H181.704z M198.454,160.867l-0.201,17.554h-16.616v-17.554h0.067H198.454z M181.704,123.213v-18.425h17.353l-0.201,18.425 H181.704z M155.105,150.817v-17.554h16.549v17.554H155.105z M171.654,160.867v17.554h-16.549v-17.554H171.654z M155.105,123.213 v-18.425h16.549v18.425H155.105z M128.506,150.817v-17.554h16.549v17.554H128.506z M145.055,160.867v17.554h-16.549v-17.554 H145.055z M128.506,123.213v-18.425h16.549v18.425H128.506z M101.907,150.817v-17.554h16.549v17.554H101.907z M118.456,160.867 v17.554h-16.549v-17.554H118.456z M101.907,123.213v-18.425h16.549v18.425H101.907z M91.857,133.263v17.554h-17.42v-17.554 H91.857z M74.437,123.213v-18.425h17.42v18.425H74.437z M74.504,160.867h17.42v17.554h-17.42V160.867z M47.905,104.788h16.549 v18.425H47.905V104.788z M47.905,133.263h16.549v17.554H47.905V133.263z M47.905,160.867h16.549v17.554H47.905V160.867z M21.306,104.788h16.549v18.425H21.306V104.788z M21.306,133.263h16.549v17.554H21.306V133.263z M21.306,178.421v-17.554h16.549 v17.554H21.306z M271.752,284.415H28.408l18.626-95.944h206.159L271.752,284.415z M278.854,178.421h-16.549v-17.554h16.549 V178.421z M278.854,150.817h-16.549v-17.554h16.549V150.817z M278.854,123.213h-16.549v-18.425h16.549V123.213z" />
                  <path d="M115.776,50.585c-8.71,0-15.745,7.035-15.745,15.745s7.035,15.745,15.745,15.745c8.643,0,15.745-7.035,15.745-15.745 S124.486,50.585,115.776,50.585z M115.776,72.025c-3.149,0-5.695-2.546-5.695-5.695s2.546-5.695,5.695-5.695 c3.082,0,5.695,2.546,5.695,5.695S118.925,72.025,115.776,72.025z" />
                </svg>
                {!isCollapsed && <span className="text">Court Booking</span>}
              </Link>
              <ul className='subsection'>
                {hasPrivilege(userData, 'COURTS', 'COURT_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/courtlist"
                      className={window.location.pathname === '/courtlist' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Court List
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'COURTS', 'BOOKING_CALENDAR_VIEW') && (
                  <li>
                    <Link
                      to="/bookingcalendar"
                      className={window.location.pathname === '/bookingcalendar' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Booking Calendar
                    </Link>
                  </li>
                )}

                {/* {hasPrivilege(userData, 'COURTS', 'COURT_BOOKINGS_VIEW') && (
                  <li>
                    <Link
                      to="/courtbookings"
                      className={window.location.pathname === '/courtbookings' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Court Bookings
                    </Link>
                  </li>
                )} */}
                {hasPrivilege(userData, 'COURTS', 'COURT_PRICING_VIEW') && (
                  <li>
                    <Link
                      to="/courtprice"
                      className={window.location.pathname === '/courtprice' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Court Pricing
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'COURTS', 'COURT_PRICING_VIEW') && (
                  <li>
                    <Link
                      to="/courtPricing"
                      className={window.location.pathname === '/courtPricing' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      New Court Price
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'COURTS', 'COURT_BULK_BOOKING_VIEW') && (
                  <li>
                    <Link
                      to="/courtbulkbooking"
                      className={window.location.pathname === '/courtbulkbooking' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Create Bulk Booking
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'COURTS', 'BULK_BOOKING_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/bulkbookinglist"
                      className={window.location.pathname === '/bulkbookinglist' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Bulk Booking List
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'COURTS', 'BLOCK_COURT_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/blockcourt"
                      className={window.location.pathname === '/blockcourt' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Block Court List
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {selectedCenter && hasPrivilege(userData, 'ACADEMY_PROFILE') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 16 16"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    fill="#dcdcdc"
                    className="inline-block align-middle"
                  >
                    <path d="M15.090 12.79c0.235-0.185 0.385-0.469 0.385-0.789 0-0.358-0.188-0.672-0.471-0.849l-0.004-5.822-1 0.67v5.15c-0.283 0.18-0.468 0.492-0.468 0.847 0 0.316 0.147 0.598 0.376 0.782l-0.378 0.502c-0.323 0.41-0.521 0.931-0.53 1.498l-0 1.222h0.81c0.002 0 0.004 0 0.005 0 0.411 0 0.757-0.282 0.853-0.664l0.331-1.336v2h1v-1.21c-0.009-0.569-0.207-1.090-0.534-1.505z" />
                    <path d="M8 0l-8 4 8 5 8-5-8-4z" />
                    <path d="M8 10l-5-3.33v1.71c0 0.91 2.94 3.62 5 3.62s5-2.71 5-3.62v-1.71z" />
                  </svg>
                </span>
                {!isCollapsed && <span className="text">Academy Profile</span>}
              </Link>
              <ul className='subsection'>
                {hasPrivilege(userData, 'ACADEMY_PROFILE', 'EDIT_PROFILE_VIEW') && (
                  <li>
                    <Link
                      to="/editprofile"
                      className={window.location.pathname === '/editprofile' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Edit Profile
                    </Link>
                  </li>)}

                {hasPrivilege(userData, 'ACADEMY_PROFILE', 'BANK_DETAILS_VIEW') && (
                  <li>
                    <Link
                      to="/bankdetails"
                      className={window.location.pathname === '/bankdetails' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Bank Details
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'ACADEMY_PROFILE', 'FEES_SETTINGS_VIEW') && (
                  <li>
                    <Link
                      to="/feesSetting"
                      className={window.location.pathname === '/feesSetting' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Fees Settings
                    </Link>
                  </li>)}

                {hasPrivilege(userData, 'ACADEMY_PROFILE', 'ACADEMY_GALLERY_VIEW') && (
                  <li>
                    <Link
                      to="/academygallery"
                      className={window.location.pathname === '/academygallery' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Academy Gallery
                    </Link>
                  </li>)}

                {/* {hasPrivilege(userData, 'ACADEMY_PROFILE', 'RESET_PASSWORD_VIEW') && (
                  <li>
                    <Link
                      to="/resetPassword"
                      className={window.location.pathname === '/resetPassword' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Reset Password
                    </Link>
                  </li>
                )} */}
              </ul>
            </li>
          )}

          {hasPrivilege(userData, 'REPORTS') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon">
                  <svg
                    viewBox="0 0 608.336 608.336"
                    className="icon"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="29"
                    height="29"
                    fill="none"
                    stroke="white"
                    strokeWidth="9.8"
                  >
                    <g transform="translate(1 1)">
                      <g>
                        <g>
                          <path d="M472.6,16.067H37.4c-21.333,0-38.4,17.067-38.4,38.4v260.267v38.4c0,21.333,17.067,38.4,38.4,38.4h163.84l-12.8,51.2 h-1.707c-23.893,0-42.667,18.773-42.667,42.667c0,5.12,3.413,8.533,8.533,8.533h204.8c5.12,0,8.533-3.413,8.533-8.533 c0-23.893-18.773-42.667-42.667-42.667h-1.707l-12.8-51.2H472.6c21.333,0,38.4-17.067,38.4-38.4v-38.4V54.467 C511,33.133,493.933,16.067,472.6,16.067z M16.067,54.467c0-11.947,9.387-21.333,21.333-21.333h435.2 c11.947,0,21.333,9.387,21.333,21.333V306.2H16.067V54.467z M348.013,476.867H162.84c3.413-10.24,12.8-17.067,23.893-17.067 h8.533h119.467h9.387C335.213,459.8,344.6,466.627,348.013,476.867z M303.64,442.733h-97.28l12.8-51.2h71.68L303.64,442.733z M493.933,353.133c0,11.947-9.387,21.333-21.333,21.333H297.667h-85.333H37.4c-11.947,0-21.333-9.387-21.333-21.333v-29.867 h477.867V353.133z" />
                          <path d="M67.267,229.4v17.067v42.667h68.267v-42.667V229.4v-42.667H67.267V229.4z M118.467,272.067H84.333v-25.6h34.133V272.067z M84.333,203.8h34.133v25.6H84.333V203.8z" />
                          <path d="M144.067,229.4v17.067v42.667h68.267v-42.667V229.4v-76.8h-68.267V229.4z M195.267,272.067h-34.133v-25.6h34.133V272.067 z M161.133,169.667h34.133V229.4h-34.133V169.667z" />
                          <path d="M220.867,229.4v17.067v42.667h68.267v-42.667V229.4v-128h-68.267V229.4z M272.067,272.067h-34.133v-25.6h34.133V272.067z M237.933,118.467h34.133V229.4h-34.133V118.467z" />
                          <path d="M297.667,229.4v17.067v42.667h68.267v-42.667V229.4v-68.267h-68.267V229.4z M348.867,272.067h-34.133v-25.6h34.133 V272.067z M314.733,178.2h34.133v51.2h-34.133V178.2z" />
                          <path d="M374.467,229.4v17.067v42.667h68.267v-42.667V229.4V50.2h-68.267V229.4z M425.667,272.067h-34.133v-25.6h34.133V272.067z M391.533,67.267h34.133V229.4h-34.133V67.267z" />
                          <path d="M127,58.733H84.333c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h22.187l-45.227,45.227 c-3.413,3.413-3.413,8.533,0,11.947c1.707,1.707,3.413,2.56,5.973,2.56s4.267-0.853,5.973-2.56l45.227-45.227v22.187 c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533V67.267C135.533,62.147,132.12,58.733,127,58.733z" />
                        </g>
                      </g>
                    </g>
                  </svg>

                </span>
                {!isCollapsed && <span className="text">Reports</span>}
              </Link>
              <ul className='subsection'>

                {hasPrivilege(userData, 'REPORTS', 'LOGIN_REPORT_VIEW') && (
                  <li>
                    <Link
                      to="/loginreport"
                      className={window.location.pathname === '/loginreport' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Login Report
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'REPORTS', 'CAREER_APPLICATIONS_VIEW') && (
                  <li>
                    <Link
                      to="/careerApplications"
                      className={window.location.pathname === '/careerApplications' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Career Applicants
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'REPORTS', 'WINTER_SALES') && (
                  <li>
                    <Link
                      to="/winterSales"
                      className={window.location.pathname === '/winterSales' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Winter Sales
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'REPORTS', 'COUPONS_USAGE_REPORT_VIEW') && (
                  <li>
                    <Link
                      to="/couponsusagereport"
                      className={window.location.pathname === '/couponsusagereport' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Coupons Usage Report
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'REPORTS', 'PLAY_TRIAL_REPORT_VIEW') && (
                  <li>
                    <Link
                      to="/playtrailreport"
                      className={window.location.pathname === '/playtrailreport' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Play Trial Report
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'REPORTS', 'LEARN_TRIAL_REPORT_VIEW') && (
                  <li>
                    <Link
                      to="/learntrailreports"
                      className={window.location.pathname === '/learntrailreports' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Learn Trial Reports
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'REPORTS', 'CHECKIN_REPORT_VIEW') && (
                  <li>
                    <Link
                      to="/checkinreport"
                      className={window.location.pathname === '/checkinreport' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Checkin Reports
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'REPORTS', 'PLAYING_SUBSCRIPTIONS_VIEW') && (
                  <li>
                    <Link
                      to="/playingsubscription"
                      className={window.location.pathname === '/playingsubscription' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Old Playing Subscription
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'REPORTS', 'PLAYING_SUBSCRIPTIONS_VIEW') && (
                  <li>
                    <Link
                      to="/newPlayingSubscription"
                      className={window.location.pathname === '/newPlayingSubscription' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      New Playing Subscription
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'REPORTS', 'LEAVE_REPORT_VIEW') && (
                  <li>
                    <Link
                      to="/leavereport"
                      className={window.location.pathname === '/leavereport' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Leave Report
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'REPORTS', 'SALES_REGISTER_VIEW') && (
                  <li>
                    <Link
                      to="/salesRegister"
                      className={window.location.pathname === '/salesRegister' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Sales Register
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {hasPrivilege(userData, 'RAZORPAY_AUTHORIZATION') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon">
                  <svg
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#dcdcdc"
                    height="30px"
                    width="30px"
                    strokeWidth="2.5"
                  >
                    <path d="M448.43,54.98H26.917C12.075,54.98,0,67.055,0,81.897v274.899c0,14.842,12.075,26.917,26.917,26.917h293.226 c4.744,0,8.591-3.846,8.591-8.591s-3.846-8.591-8.591-8.591H26.917c-5.369,0-9.736-4.367-9.736-9.736V81.897 c0-5.369,4.367-9.736,9.736-9.736H448.43c5.369,0,9.736,4.367,9.736,9.736v119.125c0,4.744,3.846,8.591,8.591,8.591 c4.744,0,8.591-3.846,8.591-8.591V81.897C475.347,67.055,463.272,54.98,448.43,54.98z"></path>
                    <path d="M146.04,119.123H72.734c-9.79,0-17.754,7.964-17.754,17.754v54.98c0,9.79,7.964,17.754,17.754,17.754h73.307 c9.79,0,17.754-7.964,17.754-17.754v-54.98C163.794,127.087,155.83,119.123,146.04,119.123z M91.633,192.43H72.734 c-0.316,0-0.573-0.257-0.573-0.573v-54.98c0-0.316,0.257-0.573,0.573-0.573h18.899V192.43z M146.613,191.857 c0,0.316-0.257,0.573-0.573,0.573h-37.226v-19.472h9.736c4.744,0,8.591-3.846,8.591-8.591s-3.846-8.591-8.591-8.591h-9.736 v-19.472h37.226c0.316,0,0.573,0.257,0.573,0.573V191.857z"></path>
                    <path d="M370.541,109.96c-10.145,0-19.587,3.055-27.467,8.283c-8.113-5.377-17.668-8.283-27.513-8.283 c-27.474,0-49.826,22.352-49.826,49.826s22.352,49.826,49.826,49.826c10.148,0,19.593-3.057,27.476-8.288 c8.114,5.372,17.681,8.288,27.504,8.288c27.474,0,49.826-22.352,49.826-49.826S398.015,109.96,370.541,109.96z M330.171,188.965 c-4.4,2.212-9.359,3.465-14.61,3.465c-18,0-32.644-14.644-32.644-32.644s14.644-32.644,32.644-32.644 c5.123,0,10.124,1.207,14.629,3.466c-5.953,8.208-9.475,18.287-9.475,29.178C320.716,170.378,324.086,180.55,330.171,188.965z M370.541,192.43c-5.114,0-10.12-1.21-14.628-3.468c5.952-8.208,9.474-18.285,9.474-29.176c0-4.744-3.846-8.591-8.591-8.591 c-4.744,0-8.591,3.846-8.591,8.591c0,6.469-1.899,12.501-5.159,17.579c-3.324-5.196-5.15-11.273-5.15-17.579 c0-18,14.644-32.644,32.644-32.644s32.644,14.644,32.644,32.644S388.542,192.43,370.541,192.43z"></path>
                    <path d="M136.877,256.573H63.57c-4.744,0-8.591,3.846-8.591,8.591c0,4.744,3.846,8.591,8.591,8.591h73.306 c4.744,0,8.591-3.846,8.591-8.591C145.468,260.419,141.621,256.573,136.877,256.573z"></path>
                    <path d="M329.307,311.553H63.57c-4.744,0-8.591,3.846-8.591,8.591c0,4.744,3.846,8.591,8.591,8.591h265.736 c4.744,0,8.591-3.846,8.591-8.591C337.897,315.399,334.051,311.553,329.307,311.553z"></path>
                    <path d="M246.837,256.573H173.53c-4.744,0-8.591,3.846-8.591,8.591c0,4.744,3.846,8.591,8.591,8.591h73.306 c4.744,0,8.591-3.846,8.591-8.591C255.427,260.419,251.581,256.573,246.837,256.573z"></path>
                    <path d="M338.47,256.573h-54.98c-4.744,0-8.591,3.846-8.591,8.591c0,4.744,3.846,8.591,8.591,8.591h54.98 c4.744,0,8.591-3.846,8.591-8.591C347.06,260.419,343.214,256.573,338.47,256.573z"></path>
                    <path d="M493.673,322.129V283.49c0-35.053-28.517-63.57-63.57-63.57s-63.57,28.517-63.57,63.57v38.639 c-10.641,3.594-18.327,13.665-18.327,25.504v82.47c0,14.842,12.075,26.917,26.917,26.917h109.96 c14.842,0,26.917-12.075,26.917-26.917v-82.47C512,335.794,504.314,325.724,493.673,322.129z M383.714,283.49 c0-25.579,20.81-46.389,46.389-46.389s46.389,20.81,46.389,46.389v37.226h-92.779V283.49z M494.819,430.103 c0,5.369-4.367,9.736-9.736,9.736h-109.96c-5.369,0-9.736-4.367-9.736-9.736v-82.47c0-5.369,4.367-9.736,9.736-9.736h109.96 c5.369,0,9.736,4.367,9.736,9.736V430.103z"></path>
                    <path d="M430.103,357.369c-12.315,0-22.336,10.02-22.336,22.336c0,9.273,5.681,17.24,13.745,20.613v11.459 c0,4.744,3.846,8.591,8.591,8.591s8.591-3.846,8.591-8.591v-11.459c8.064-3.373,13.745-11.34,13.745-20.613 C452.438,367.389,442.418,357.369,430.103,357.369z M430.103,384.859c-2.842,0-5.154-2.313-5.154-5.154 c0-2.842,2.313-5.154,5.154-5.154s5.154,2.313,5.154,5.154C435.257,382.546,432.945,384.859,430.103,384.859z"></path>
                  </svg>
                </span>
                {!isCollapsed && <span className="text">RazorPay Auth</span>}
              </Link>

              <ul className='subsection'>
                {hasPrivilege(userData, 'RAZORPAY_AUTHORIZATION', 'RAZORPAY_AUTHORIZATION_VIEW') && (
                  <li>
                    <Link
                      to="/razorpayauth"
                      className={window.location.pathname === '/razorpayauth' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Razorpay Auth Form
                    </Link>
                  </li>
                )}
              </ul>

            </li>
          )}

          {hasPrivilege(userData, 'ACTIVITY_TRACKING') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 100 100"
                    width="30px"
                    height="30px"
                    fill="none"
                    stroke="#dcdcdc"
                    strokeWidth="6"
                    strokeLinecap="round"
                  >

                    <circle cx="50" cy="50" r="45" stroke="#dcdcdc" fill="none" />


                    <line x1="50" y1="50" x2="50" y2="20" stroke="#dcdcdc">
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 50 50"
                        to="360 50 50"
                        dur="2s"
                        repeatCount="indefinite"
                      />
                    </line>


                    <circle cx="50" cy="50" r="4" fill="#dcdcdc">
                      <animate
                        attributeName="r"
                        values="4;6;4"
                        dur="1.5s"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="opacity"
                        values="1;0.5;1"
                        dur="1.5s"
                        repeatCount="indefinite"
                      />
                    </circle>
                  </svg>
                </span>



                {!isCollapsed && <span className="text">Activity Tracking</span>}
              </Link>

              <ul className='subsection'>
                {hasPrivilege(userData, 'ACTIVITY_TRACKING', 'ACTIVITY_TRACKING_VIEW') && (
                  <li>

                    <Link
                      to="/taskTracking"
                      className={window.location.pathname === '/taskTracking' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Activity Tracking
                    </Link>
                  </li>
                )}
              </ul>

            </li>
          )}

          {selectedCenter && hasPrivilege(userData, 'ATTENDANCE_VIEW') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon">
                  <svg
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    mirror-in-rtl="true"
                    height="26px"
                    width="26px"
                    stroke="#dcdcdc"
                    strokeWidth="1.2"
                    fill="none"
                  >
                    <g id="SVGRepo_iconCarrier">
                      <circle cx="6" cy="12" r="2" />
                      <path d="M8.708 5.717l-1.954 1.96c-.25.243-.61.37-.958.307C5.5 7.93 4.64 7.327 4.458 7.21c-.46-.29-.6-.91-.3-1.383.29-.46.91-.602 1.38-.3l.32.2 1.43-1.435c.39-.39 1.03-.39 1.42 0 .39.392.39 1.034 0 1.425z" />
                      <path d="M20 7c0 .55-.45 1-1 1h-8.01c-.55-.01-.99-.45-.99-1s.44-.99.99-1H19c.55 0 1 .45 1 1z" />
                      <circle cx="6" cy="18" r="2" />
                      <path d="M20 13c0 .55-.45 1-1 1h-8.01c-.55-.01-.99-.45-.99-1s.44-.99.99-1H19c.55 0 1 .45 1 1zM20 19c0 .55-.45 1-1 1h-8.01c-.55-.01-.99-.45-.99-1s.44-.99.99-1H19c.55 0 1 .45 1 1z" />
                      <path d="M22 0H2C.9 0 0 .9 0 2v20c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 21.5c0 .276-.224.5-.5.5h-19c-.276 0-.5-.224-.5-.5v-19c0-.276.224-.5.5-.5h19c.276 0 .5.224.5.5v19z" />
                    </g>
                  </svg>
                </span>
                {!isCollapsed && <span className="text">Checkin Attendance</span>}
              </Link>


              <ul className='subsection'>
                {hasPrivilege(userData, 'ATTENDANCE_VIEW', 'CHECKIN_ATTENDANCE_VIEW') && (
                  <li>
                    <Link
                      to="/searchuser"
                      className={window.location.pathname === '/searchuser' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Search User
                    </Link>
                  </li>
                )}
              </ul>

            </li>
          )}
          {hasPrivilege(userData, 'USER_ROLE') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon">
                  <svg
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    mirror-in-rtl="true"
                    height="27px"
                    width="27px"
                    stroke="#dcdcdc"
                    strokeWidth="1.5"
                    fill="none"
                  >
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M4 21C4 17.4735 6.60771 14.5561 10 14.0709M19.8726 15.2038C19.8044 15.2079 19.7357 15.21 19.6667 15.21C18.6422 15.21 17.7077 14.7524 17 14C16.2923 14.7524 15.3578 15.2099 14.3333 15.2099C14.2643 15.2099 14.1956 15.2078 14.1274 15.2037C14.0442 15.5853 14 15.9855 14 16.3979C14 18.6121 15.2748 20.4725 17 21C18.7252 20.4725 20 18.6121 20 16.3979C20 15.9855 19.9558 15.5853 19.8726 15.2038ZM15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z"
                        stroke="#dcdcdc"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </g>
                  </svg>
                </span>
                {!isCollapsed && <span className="text">User Role</span>}
              </Link>


              <ul className='subsection'>
                {hasPrivilege(userData, 'USER_ROLE', 'USER_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/UserList"
                      className={window.location.pathname === '/UserList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      User List
                    </Link>
                  </li>
                )}
                {hasPrivilege(userData, 'USER_ROLE', 'ROLE_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/RoleList"
                      className={window.location.pathname === '/RoleList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Role List
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {hasPrivilege(userData, 'PLAYING_PLAN') && (
            <li className="menu-item">
              <Link to="/" onClick={() => setActiveSection(null)}>
                <span className="icon">    <svg
                  viewBox="0 0 608.336 608.336"
                  className="icon"
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  fill="none"
                  stroke="white"
                  strokeWidth="9.8"
                >
                  <g>
                    <g>
                      <path d="M144.128,282.748h-13.177v-13.177c0-11.83-9.59-21.42-21.42-21.42s-21.42,9.59-21.42,21.42v13.177H74.935 c-11.83,0-21.42,9.59-21.42,21.42c0,11.83,9.59,21.419,21.42,21.419h13.177v13.178c0,11.83,9.59,21.42,21.42,21.42 s21.42-9.59,21.42-21.42v-13.178h13.177c11.83,0,21.42-9.59,21.42-21.419C165.548,292.337,155.958,282.748,144.128,282.748z" />
                      <path d="M109.532,360.685c-12.087,0-21.92-9.833-21.92-21.92v-12.678H74.935c-12.087,0-21.92-9.833-21.92-21.919 c0-12.087,9.833-21.92,21.92-21.92h12.677v-12.677c0-12.087,9.833-21.92,21.92-21.92s21.92,9.833,21.92,21.92v12.677h12.677 c12.087,0,21.92,9.833,21.92,21.92c0,12.086-9.833,21.919-21.92,21.919h-12.677v12.678 C131.452,350.852,121.619,360.685,109.532,360.685z M74.935,283.248c-11.535,0-20.92,9.385-20.92,20.92 c0,11.535,9.385,20.919,20.92,20.919h13.677v13.678c0,11.535,9.385,20.92,20.92,20.92s20.92-9.385,20.92-20.92v-13.678h13.677 c11.535,0,20.92-9.385,20.92-20.919c0-11.535-9.385-20.92-20.92-20.92h-13.677v-13.677c0-11.535-9.385-20.92-20.92-20.92 s-20.92,9.385-20.92,20.92v13.677H74.935z" />
                    </g>
                    <g>
                      <path d="M564.922,162.659c-13.441-13.441-29.105-24-46.557-31.381c-18.092-7.651-37.283-11.531-57.043-11.531h-314.31 c-19.76,0-38.952,3.879-57.042,11.531c-17.452,7.381-33.116,17.939-46.558,31.381s-24,29.105-31.382,46.557 C4.379,227.307,0.5,246.499,0.5,266.259v75.818c0,19.76,3.879,38.951,11.531,57.043c7.382,17.451,17.939,33.115,31.381,46.557 c13.441,13.441,29.106,24,46.557,31.381c18.091,7.652,37.283,11.531,57.043,11.531h314.31c19.762,0,38.953-3.879,57.043-11.531 c17.453-7.381,33.117-17.939,46.559-31.381c13.439-13.441,23.998-29.105,31.381-46.557c7.65-18.09,11.531-37.283,11.531-57.043 v-75.818c0-19.76-3.879-38.952-11.531-57.043C588.922,191.765,578.365,176.101,564.922,162.659z M564.996,342.077 c0,57.256-46.416,103.672-103.674,103.672h-314.31c-57.257,0-103.672-46.416-103.672-103.672v-75.818 c0-57.257,46.416-103.672,103.672-103.672h314.31c57.258,0,103.674,46.416,103.674,103.672V342.077L564.996,342.077z" />
                      <path d="M461.322,489.089h-314.31c-19.829,0-39.087-3.893-57.238-11.571c-17.511-7.405-33.228-18-46.716-31.487 c-13.486-13.486-24.081-29.203-31.488-46.716C3.893,381.162,0,361.904,0,342.077v-75.818c0-19.828,3.893-39.085,11.57-57.238 c7.408-17.513,18.002-33.23,31.489-46.716c13.488-13.487,29.206-24.082,46.716-31.488c18.151-7.678,37.409-11.571,57.237-11.571 h314.31c19.826,0,39.083,3.893,57.237,11.571c17.512,7.407,33.229,18,46.716,31.488c13.485,13.483,24.08,29.201,31.489,46.716 c7.679,18.151,11.571,37.409,11.571,57.238v75.818c0,19.825-3.893,39.083-11.57,57.237c-7.408,17.511-18.002,33.228-31.488,46.716 c-13.488,13.488-29.206,24.082-46.718,31.488C500.41,485.196,481.152,489.089,461.322,489.089z M147.012,120.247 c-19.694,0-38.82,3.866-56.848,11.492c-17.392,7.356-33.002,17.878-46.399,31.274c-13.395,13.395-23.917,29.005-31.275,46.398 C4.866,227.44,1,246.566,1,266.259v75.818c0,19.692,3.866,38.819,11.492,56.849c7.357,17.393,17.879,33.003,31.274,46.397 c13.396,13.396,29.007,23.918,46.398,31.273c18.027,7.626,37.153,11.492,56.848,11.492h314.31 c19.695,0,38.822-3.866,56.849-11.492c17.392-7.354,33.003-17.877,46.399-31.273c13.395-13.396,23.917-29.007,31.273-46.398 c7.626-18.03,11.492-37.157,11.492-56.848v-75.818c0-19.695-3.866-38.821-11.492-56.848 c-7.358-17.396-17.881-33.006-31.275-46.398c-13.396-13.396-29.006-23.917-46.397-31.274 c-18.031-7.625-37.157-11.492-56.849-11.492H147.012z M461.322,446.249h-314.31c-57.441,0-104.172-46.731-104.172-104.172v-75.818 c0-57.441,46.731-104.172,104.172-104.172h314.31c57.441,0,104.174,46.731,104.174,104.172v75.818 C565.496,399.518,518.764,446.249,461.322,446.249z M147.012,163.087c-56.89,0-103.172,46.283-103.172,103.172v75.818 c0,56.889,46.283,103.172,103.172,103.172h314.31c56.891,0,103.174-46.283,103.174-103.172v-75.818 c0-56.89-46.283-103.172-103.174-103.172H147.012z" />
                    </g>
                    <g>
                      <circle cx="519.246" cy="270.652" r="21.42" />
                      <path d="M519.246,292.572c-12.087,0-21.92-9.833-21.92-21.919c0-12.087,9.833-21.92,21.92-21.92s21.92,9.833,21.92,21.92 C541.166,282.739,531.333,292.572,519.246,292.572z M519.246,249.732c-11.535,0-20.92,9.385-20.92,20.92 c0,11.535,9.385,20.919,20.92,20.919s20.92-9.384,20.92-20.919C540.166,259.117,530.781,249.732,519.246,249.732z" />
                    </g>
                    <g>
                      <circle cx="471.281" cy="318.616" r="21.42" />
                      <path d="M471.281,340.536c-12.087,0-21.92-9.833-21.92-21.92c0-12.086,9.833-21.919,21.92-21.919s21.92,9.833,21.92,21.919 C493.201,330.703,483.368,340.536,471.281,340.536z M471.281,297.697c-11.535,0-20.92,9.384-20.92,20.919s9.385,20.92,20.92,20.92 s20.92-9.385,20.92-20.92S482.816,297.697,471.281,297.697z" />
                    </g>
                    <g>
                      <path d="M370.545,185.779h-137.04c-32.059,0-58.14,26.082-58.14,58.14v122.662c0,32.059,26.082,58.141,58.14,58.141h137.04 c32.059,0,58.141-26.082,58.141-58.141V243.919C428.686,211.86,402.604,185.779,370.545,185.779z M385.846,366.581 c0,8.438-6.863,15.301-15.301,15.301h-137.04c-8.437,0-15.3-6.863-15.3-15.301V243.919c0-8.437,6.864-15.3,15.3-15.3h137.04 c8.438,0,15.301,6.864,15.301,15.3V366.581z" />
                      <path d="M370.545,425.222h-137.04c-32.334,0-58.64-26.306-58.64-58.641V243.919c0-32.334,26.306-58.64,58.64-58.64h137.04 c32.335,0,58.641,26.306,58.641,58.64v122.662C429.186,398.916,402.88,425.222,370.545,425.222z M233.505,186.279 c-31.783,0-57.64,25.857-57.64,57.64v122.662c0,31.783,25.857,57.641,57.64,57.641h137.04c31.783,0,57.641-25.857,57.641-57.641 V243.919c0-31.783-25.857-57.64-57.641-57.64H233.505z M370.545,382.382h-137.04c-8.712,0-15.8-7.088-15.8-15.801V243.919 c0-8.712,7.088-15.8,15.8-15.8h137.04c8.713,0,15.801,7.088,15.801,15.8v122.662C386.346,375.294,379.258,382.382,370.545,382.382 z M233.505,229.119c-8.161,0-14.8,6.639-14.8,14.8v122.662c0,8.161,6.639,14.801,14.8,14.801h137.04 c8.161,0,14.801-6.64,14.801-14.801V243.919c0-8.161-6.64-14.8-14.801-14.8H233.505z" />
                    </g>
                  </g>
                </svg></span>

                {!isCollapsed && <span className="text">Playing Plans</span>}
              </Link>

              <ul className='subsection'>
                {hasPrivilege(userData, 'PLAYING_PLAN', 'PLANS_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/planList"
                      className={window.location.pathname === '/planList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Plan List
                    </Link>
                  </li>
                )}

                {hasPrivilege(userData, 'PLAYING_PLAN', 'PLANS_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/oldPlanList"
                      className={window.location.pathname === '/oldPlanList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      OLd Plan List
                    </Link>
                  </li>
                )}

                {/* {hasPrivilege(userData, 'PLAYING_PLAN', 'CREATE_PLAN_VIEW') && (
                  <li>
                    <Link
                      to="/newPlan"
                      className={window.location.pathname === '/newPlan' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Create Plan
                    </Link>
                  </li>
                )} */}

                {hasPrivilege(userData, 'PLAYING_PLAN', 'PLANS_LIST_VIEW') && (
                  <li>
                    <Link
                      to="/passList"
                      className={window.location.pathname === '/passList' ? 'active' : ''}
                      onClick={handleSubsectionClick}
                    >
                      Pass List
                    </Link>
                  </li>
                )}

              </ul>
            </li>
          )}

        </ul>
        <div className="sidebar-toggle" onClick={onToggle}>
          {window.innerWidth <= 600
            ? "\u25B6\uFE0E"
            : isCollapsed
              ? "\u25B6\uFE0E"
              : "\u25C0\uFE0E"
          }
        </div>
      </nav>

    </div>
  );
};

export default Sidebar;